var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "placeholder_eth",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_132",
    "data-name": "\\u77E9\\u5F62 132",
    width: 49,
    height: 48,
    fill: "#141619"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_512",
    "data-name": "\\u7EC4 512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_725",
    "data-name": "\\u8DEF\\u5F84 725",
    d: "M25,5l-.24.843V30.3l.24.247,11-6.711Z",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_726",
    "data-name": "\\u8DEF\\u5F84 726",
    d: "M25,5,14,23.839,25,30.55V5Z",
    fill: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_727",
    "data-name": "\\u8DEF\\u5F84 727",
    d: "M25,32.7l-.135.17v8.713l.135.408,11-16Z",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_728",
    "data-name": "\\u8DEF\\u5F84 728",
    d: "M25,41.992V32.7L14,25.992Z",
    fill: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_729",
    "data-name": "\\u8DEF\\u5F84 729",
    d: "M25,30.55l11-6.711L25,18.678Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_730",
    "data-name": "\\u8DEF\\u5F84 730",
    d: "M14,23.839,25,30.55V18.678Z",
    fill: "#323232"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.500fdf7cc072197f31feb9920eebb767.svg";
export { ForwardRef as ReactComponent };